import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Col, Divider, Form, Input, Row, Select } from 'antd';
import React from 'react';

import IBaseComponent from '../Interfaces/Base/IBaseComponent';
import { ComponentProp } from '../Interfaces/ISectionCondition';

const FormItem = Form.Item;
const Option = Select.Option;
interface ITextConditionComponentProps {
  selectComponentCondition: IBaseComponent[];
  idCurrentConditionComponent: string;
  form: any;
  getConditionOptionCompare: Function;
  onChangeOption: Function;
  onChangeOptionCompare: Function;
  onChangeValue?: any;
  valueOption: number;
  valueOptionCompare: number;
  valueInput: string;
  withoutCount: boolean;
  // isMask: boolean;

};


interface ITextConditionComponentStateType {

};
export default class ConditionCompareValue extends React.Component<ITextConditionComponentProps, ITextConditionComponentStateType> {

  constructor(props: ITextConditionComponentProps) {
    super(props);
    this.state = {

    };
  }
  getConditionOption() {
    const conditionOption: JSX.Element[] = [];
    conditionOption.push(
      <Option value={ComponentProp.VALUE}>{I18n.l("formflow.conditions.propValue")}</Option>,
      <Option value={ComponentProp.COUNT}>{I18n.l("formflow.conditions.propCount")}</Option>,
      <Option value={ComponentProp.FILLED}>{I18n.l("formflow.conditions.propFilled")}</Option>
    );
    return conditionOption;
  }

  getConditionOptionWithoutCount() {
    const conditionOption: JSX.Element[] = [];
    conditionOption.push(
      <Option value={ComponentProp.VALUE}>{I18n.l("formflow.conditions.propValue")}</Option>,
      <Option value={ComponentProp.FILLED}>{I18n.l("formflow.conditions.propFilled")}</Option>
    );
    return conditionOption;
  }
  render() {
    return (
      <React.Fragment>
        <React.Fragment >
          {
            <span style={{ marginBottom: '10px', position: "relative"  }} id="area" >
              <Form>
                <FormItem
                >
                  <Row>
                    <Col sm={8} md={8} xl={8}>
                      {
                        this.props.withoutCount === true &&
                        <Select
                          defaultValue={this.props.valueOption}
                          getPopupContainer={ () => document.getElementById("area")}
                          placeholder={I18n.l("formflow.conditions.selectOptionPlaceholder")}
                          style={{ width: '100%' }}
                          onChange={this.props.onChangeOption()}
                        >
                          {this.getConditionOptionWithoutCount()}
                        </Select>
                      }

                      {
                        this.props.withoutCount === false &&
                        <Select
                          defaultValue={this.props.valueOption}
                          getPopupContainer={ () => document.getElementById("area")}
                          placeholder={I18n.l("formflow.conditions.selectOptionPlaceholder")}
                          style={{ width: '100%' }}
                          onChange={this.props.onChangeOption()}
                        >
                          {this.getConditionOption()}
                        </Select>
                      }
                      <div style={{ fontWeight: 'bold', color: `${Theme.secondary.red}`, marginTop: '-10px' }} >
                        {this.props.valueOption === undefined && I18n.l("form.validation.field.required")}
                      </div>
                    </Col>
                    <Col sm={8} md={8} xl={8}>
                      <Select
                        defaultValue={this.props.valueOptionCompare}
                        getPopupContainer={ () => document.getElementById("area")}
                        placeholder={I18n.l("formflow.conditions.selectComparePlaceholder")}
                        style={{ width: '100%', marginLeft: '10px' }}
                        onChange={this.props.onChangeOptionCompare()}
                      >
                        {this.props.getConditionOptionCompare()}
                      </Select>
                      <div style={{ fontWeight: 'bold', color: `${Theme.secondary.red}`, marginTop: '-10px', paddingLeft: '10px' }} >
                        {this.props.valueOptionCompare === undefined && I18n.l("form.validation.field.required")}
                      </div>
                    </Col>
                    <Col sm={8} md={8} xl={8}>
                      {
                        // this.props.isMask === false &&
                        <Input
                          defaultValue={this.props.valueInput}
                          placeholder={I18n.l("formflow.conditions.selectValuePlaceholder")}
                          style={{ width: '90%', marginLeft: '20px' }}
                          onChange={this.props.onChangeValue()}
                        />
                      }
                      <div style={{ fontWeight: 'bold', color: `${Theme.secondary.red}`, marginTop: '-10px', paddingLeft: '20px' }} >
                        {this.props.valueInput === undefined && I18n.l("form.validation.field.required")}
                      </div>
                    </Col>
                  </Row>
                </FormItem>
              </Form>
            </span>
          }
        </React.Fragment>
        <Divider />
      </React.Fragment>
    )
  }
}
export const ConditionWithValue = Form.create()(ConditionCompareValue);

